export default "__VITE_ASSET__CYMEqcNO__"